










import { Vue, Component } from 'vue-property-decorator';
import TipoContacto from '@/pantallas/TipoContacto/TipoContacto.vue';

@Component({
  components: { TipoContacto },
})
export default class TipoContactoPantalla extends Vue {}
